<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="New Password" prop="newPassword">
        <a-input-password v-model="form.newPassword" placeholder="Please enter new password" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Confirm Password" prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" placeholder="Please confirm password" :maxLength="20" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { resetPassword} from '@/api/biz/user'
export default {
  name: 'ResetPassword',
  props: {
  },
  data () {
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter new password'))
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/.test(value)) {
        callback(new Error('Please enter a 6-12 character password with letters and numbers'))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please re-enter the new password to confirm'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('The two passwords do not match'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      title: 'Reset Password',
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      rules: {
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // Cancel button
    cancel () {
      this.open = false
      this.reset()
    },
    // Reset form
    reset () {
      this.form = {
        id: undefined,
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    },
    handleResetPwd (row) {
      this.form = {
        id: row.id,
        userName: row.userName
      }
      this.open = true
    },
    /** Reset password action */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          resetPassword({id:this.form.id,password:this.form.newPassword}).then(response => {
            this.$message.success(
              'Reset successful',
              3
            )
            this.open = false
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
